import { Component } from 'react';
import { browserHistory } from 'react-router';
import FontsAPI from '../api/FontsAPI';
import { getFontUrlName } from '../helpers/fonts';

export default class GeneratorContainer extends Component {
  componentDidMount() {
    const response = FontsAPI.getRandomPair();

    const {
      primaryName,
      secondaryName,
    } = response;

    const primaryNameUrl = getFontUrlName(primaryName)
    const secondaryNameUrl = getFontUrlName(secondaryName)
    browserHistory.push('/' + primaryNameUrl + '+' + secondaryNameUrl);
  }

  render () {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/containers/GeneratorContainer.jsx